import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { campaignsApi, staticAdv } from '@/api/index';
import type { CampaignText } from '@/api/routes/campaigns/types';
import type { StaticAdvType, VideoAdvType } from '@/api/routes/static-adv/types';

export const fetchCampaignNames = createAsyncThunk(
  'names',
  async (params: CampaignText<VideoAdvType>, thunkAPI) => {
    try {
      const response = await campaignsApi.getNames(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchCampaignStaticNames = createAsyncThunk(
  'names',
  async (params: CampaignText<StaticAdvType[]>, thunkAPI) => {
    try {
      const response = await staticAdv.getNames(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
